// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"-mwdZ_YV8u","updatePasswordForm":"_28gdWBI1px","input":"_2WF8cNzwBO","label":"_3jSgWl3pp8"};